import React from "react"
import {Modal} from "reactstrap";
import BaseComponent from "../base-component";

class SuccessModal extends BaseComponent {
    render() {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className={'bg-gasnet-green' + (this.props.className || '')} size='lg'>
                { this.props.children }
            </Modal>
        );
    };
}

export default SuccessModal;
